<template>
  <v-dialog
    v-model="dialog"
    persistent
    transition="dialog-bottom-transition"
    max-width="600"
  >
    <div class="bg-white poppins">
      <div class="modal-header py-4 align-center">
        <h4 class="mb-0 font-weight-bolder">Assign Carrier</h4>
        <div
          class="btn btn-sm btn-icon btn-active-light-info"
          @click="toggleModal"
        >
          <span class="svg-icon">
            <v-icon size="22">mdi-close</v-icon>
          </span>
        </div>
      </div>
      <div class="modal-body d-flex flex-column scroll-y mx-5 mx-xl-15 py-7">
        <div class="row">
          <div class="col-12 col-12 h-75px">
            <v-select
              v-model="carrier_id"
              label="Select carrier"
              item-text="text"
              item-value="index"
              :items="carriers"
              clearable
              outlined
              dense
              :error-messages="carrier_id_errors"
              @input="checkValidity"
              @blur="checkValidity"
            ></v-select>
          </div>
          <div class="col-12 col-12 h-75px">
            <v-select
              v-model="carrier_account"
              label="Select account"
              item-text="text"
              item-value="index"
              :items="carrierAccounts"
              clearable
              outlined
              dense
              :disabled="!carrier_id"
              :error-messages="carrier_account_errors"
              @input="checkValidity"
              @blur="checkValidity"
            ></v-select>
          </div>
        </div>
        <div class="my-4 d-flex flex-grow-1 align-end justify-center">
          <button
            type="submit"
            class="btn btn-info px-5 py-3 ls1"
            @click="submit"
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import ApiService from "@/core/services/api.service";
import Swal from "sweetalert2";
import { SET_PAGE_LOADING } from "@/core/services/store/config.module";

export default {
  name: "AssignCarrier",
  props: ["items", "updateTableContent"],
  data: () => ({
    dialog: false,
    carrier_id: null,
    carrier_account: null,
    valid: true,
  }),
  methods: {
    toggleModal() {
      this.reset();
      this.dialog = !this.dialog;
    },
    submit() {
      this.checkValidity();
      if (this.valid) {
        this.$store.commit(SET_PAGE_LOADING, true);
        const payload = {
          ids: this.items.map((item) => item.id),
          carrier_id: this.carrier_id,
          carrier_account_id: this.carrier_account,
        };
        ApiService.post(`/shipping/returns_management/assign-carrier`, payload)
          .then(({ data }) => {
            Swal.fire({
              title: "Success",
              text: `${data.message}`,
              icon: "success",
              showConfirmButton: true,
            });
            this.toggleModal();
            this.updateTableContent();
          })
          .catch(() => {
            this.$store.commit(SET_PAGE_LOADING, false);
          });
      }
    },
    checkValidity() {
      this.valid = !!this.carrier_id;
      if (!this.carrier_id) {
        this.carrier_account = null;
      }
    },
    reset() {
      this.carrier_id = null;
      this.carrier_account = null;
      this.valid = true;
    },
  },
  computed: {
    carriers() {
      return this.$store.getters.getRETURNSCarriers;
    },
    carrierAccounts() {
      if (!this.carrier_id) return [];
      return (
        this.$store.getters.getRETURNSCarrierAccounts.filter(
          (account) => account.carrier_id === this.carrier_id
        ) || []
      );
    },
    carrier_id_errors() {
      return this.valid ? null : "This field is required";
    },
    carrier_account_errors() {
      if (this.carrier_id && !this.carrier_account) {
        return "This field is required";
      }
      return null;
    },
  },
};
</script>
